import React, { useEffect, useState } from 'react'
import SearchContainer from './POSearchContainer'
import PoReconciliationTable from './POReconciliationTable'
import useAxios from 'hooks/useAxios';
import { Card, CardBody, Container } from 'reactstrap';
import { getUpdatedFilterLatest } from 'utils/helper';
import useContextService from 'hooks/useContextService';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorBoundary from 'components/ErrorBoundary';
import { cloneDeep } from "lodash";
import Loader from 'components/Loader';
let filters = [];

const Poreconciliation = (props) => {
  const { orgId, reset, loading,
    setLoading, tabKey, resetKey } = props;
  const API = useAxios();
  const {
    states: { poReconciliation },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = poReconciliation;
  const [data, setData] = useState([]);
  const [totalitem, setTotalItem] = useState(0);
  const [openEditOrder, setOpenEditOrder] = useState(false);
  const [collapseSider, setcollapseSider] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [rowData, setrowData] = useState('');
  // const [loading, setLoading] = useState(false);
  const [resetFilterFlag, SetResetFilterFlag] = useState(false);
  useEffect(() => {
    // if (searchTerms.coveredEntityID) handleSearch(searchTerms);
    onReset();
  }, [orgId, reset]);

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    //filterObj.ActiveButton = ActiveButton
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "poreconciliation";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
  };

  const manvalConfigedit = (rowData) => {
    setrowData(rowData);
    setOpenEditOrder(!openEditOrder);
  }
  const refetch = () => {
    debugger
    setColumnFilters([]);
    poReconciliation.search.currentPage = 1;
    fetchPOReconsiliations(search)
  };
  const refetch1 = async () => {
    debugger;
    let filter = searchTerms;
    let accumulationID = filter.accumulationIDs[0].value ? filter.accumulationIDs[0].value : filter.accumulationIDs[0];
    filter.accumulationIDs = [accumulationID];
    filter.poNumber = filter.poNumber;
    if (Object.keys(filter.orderStatusId).length === 0) {
      filter.orderStatusId = 0; // Setting to 0 if empty
    }
    await handleSearch(filter);
  };
  const handleSearch = async (filter) => {
    debugger;
    const {
      accumulationIDs,
      poNumber,
      orderStatusId,
      accountTypeId,
    } = filter;

    if (orderStatusId) {
      filters = getUpdatedFilterLatest(
        'poStatusID',
        (orderStatusId),
        filters
      );
    }

    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    var isorderStatusIdEmptyValue = false;
    //search.filters = filters;
    if (orderStatusId === "") {
      orderStatusId = 0;
    }
    else {
      isorderStatusIdEmptyValue = isorderStatusIdEmpty(orderStatusId);
    }
    function isorderStatusIdEmpty(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    }

    var accId = accumulationIDs[0] > 0 ? accumulationIDs[0] : accumulationIDs[0].value
    let acID = [];
    acID.push(accId);
    search.Poid = poNumber;
    search.AccumulatorIDs = acID;
    search.POStatusID = isorderStatusIdEmptyValue === true ? 0 : orderStatusId;
    search.AccountTypeID = accountTypeId;
    await fetchPOReconsiliations(search);
  };

  const fetchPOReconsiliations = async (filters) => {
    debugger
    if (!(orgId?.tenantID)) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    try {
      if (filters.AccumulatorIDs.length > 0) {
        setLoading(true);
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/GetPOReconciliationAll`, filters,
          { hasDefaultURL: true, }
        )
        if (data?.items?.length > 0) {
          setData(data.items);
          setLoading(false);
          setTotalItem(data.totalRecords);
        } else {
          setData([]);
          setTotalItem(0);
          setLoading(false);
        }
      }
    } catch (error) { setLoading(false); }
  };
  const handlePageChange = (filter, haveColFilter) => {
    updatePoReconciliationSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      poReconciliation.search = { ...poReconciliation.search };
      fetchPOReconsiliations(filterObj);

    } else {
      fetchPOReconsiliations(filter);
      poReconciliation.search = { ...poReconciliation.search, ...filter };
    }
    setStates('poReconciliation', poReconciliation);
  };

  const updatePoReconciliationSearch = (filter) => {
    poReconciliation.search.currentPage = filter.currentPage;
    poReconciliation.search.pageSize = filter.pageSize;
    poReconciliation.search.orderBy = filter.orderBy;
    poReconciliation.search.order = filter.order;
  }

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }
  const handleSearchColumnFilters = async (columnFilters) => {
    debugger;
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters)
    }
    poReconciliation.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchPOReconsiliations(filterObj);
  };

  const onReset = () => {
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
  };
  return (
    <div>
      <div>
        <div className='border-0'>
          {/* {loading && <Loader opacity={0.01} color="black"/>} */}
          <Card className="border-0 shadow-top mb-3 durg_tabs">
            <CardBody hidden={collapseSider} className="">
              <div hidden={collapseSider} className=''>
                <ErrorBoundary>
                  <SearchContainer
                   setLoading={setLoading}
                    orgId={orgId}
                    reset={reset}
                    onSearch={handleSearch}
                    onReset={onReset}
                    tabKey={tabKey}
                  />
                </ErrorBoundary>
              </div>
            </CardBody>
          </Card>
          <Card className='border-0 shadow-top'>
            <CardBody className="">
              {/* <div className="py-2 text-center">
              <span
                style={{ fontSize: "27px", cursor: "pointer" }}
                onClick={toggleSider}
              >
                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
              </span>
            </div> */}
              <ErrorBoundary>
                <PoReconciliationTable
                  resetKey={resetKey}
                  tabKey={tabKey}
                  data={data}
                  filters={search}
                  totalitem={totalitem}
                  manvalConfigedit={manvalConfigedit}
                  rowData={rowData}
                  orgId={orgId}
                  onExport={handleExport}
                  onPageChange={handlePageChange}
                  refetch={refetch}
                  refetch1={refetch1}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                  resetFilterFlag={resetFilterFlag}
                  SetResetFilterFlag={SetResetFilterFlag}
                />
              </ErrorBoundary>
            </CardBody>

          </Card>
        </div>
      </div>
    </div>
  );
}

export default Poreconciliation
